
/**
 * 批量注册组件
 * @param {Object} context - require.context 返回的上下文
 * @param {String} prefix - 组件名称的前缀，默认为空字符串
 * @returns {Object} 包含所有注册组件的对象
 */
export const registerComponents = (context, prefix = '') => {
  return context.keys().reduce((components, fileName) => {
    const componentConfig = context(fileName)

    const componentName = prefix + fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '')

    components[componentName] = componentConfig.default || componentConfig
    
    return components
  }, {})
}